import React, { useState } from "react";
import classNames from "classnames";

import styles from "./EntryCard.module.css";
import { Tag } from "../Tag";
import { LikeButton } from "../LikeButton";

type Props = {
  title?: string;
  userName?: string;
  description?: string;
  category?: string;
  likes?: number;
  hasLiked?: boolean;
  onLocate: () => void;
  onLike: () => void;
  onUnlike: () => void;
};

const EntryCard: React.FC<Props> = ({
  title,
  userName,
  description,
  category,
  likes,
  hasLiked,
  onLocate,
  onLike,
  onUnlike,
}) => {
  const [hasClickedLike, setHasClickedLike] = useState(false);

  const wrapperClass = classNames({
    [styles["wrapper"]]: true,
  });

  // Disable button when clicked
  const handleLike = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setHasClickedLike(true);
    onLike();
  };

  const handleUnlike = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setHasClickedLike(false);
    onUnlike();
  };

  return (
    <button className={wrapperClass} onClick={onLocate}>
      <h1 className="h2">{title || "Innspel uten navn"}</h1>

      <p className="faded">Sendt inn av {userName || "Anonym"}</p>
      <p>{description || "Ingen beskrivelse"}</p>

      <div className={styles.footer}>
        <Tag>{category || "Ukjent kategori"}</Tag>
        <LikeButton
          likes={likes}
          liked={hasClickedLike || hasLiked}
          onClick={hasClickedLike ? handleUnlike : handleLike}
        />
      </div>
    </button>
  );
};

export default EntryCard;
